import axios from 'axios'
import {get} from 'lodash'
import ImageCrud from './ImageCrud.class'

const baseURL = '/api/mentor/'

export default class Mentor {
	constructor (init = {}) {
		this.id = null
		this.setDefaultData()
		if (typeof init === 'number') {
			this.id = init
			this.getSingle().then()
		} else {
			this.setDefaultData(init)
		}
	}

	setDefaultData (init = {}) {
		if (!init) return

		this.id = get(init, 'id') ? init.id : null
		this.full_name = get(init, 'full_name') ? init.full_name : ''
		this.position = get(init, 'position') ? init.position : ''
		this.signature = get(init, 'signature') ? new ImageCrud(init.signature) : new ImageCrud()
		this.new_signature = null
		this.created_at = get(init, 'created_at') && this.isValidDate(init.created_at) ? new Date(init.created_at) : null
		this.updated_at = get(init, 'updated_at') && this.isValidDate(init.updated_at) ? new Date(init.updated_at) : null
	}

	isValidDate (date) {
		return date && isNaN(date)
	}

	get formData () {
		const formData = new FormData()

		formData.append('full_name', this.full_name)
		formData.append('position', this.position)

		if (this.new_signature) {
			formData.append('signature', this.new_signature)
		}

		return formData
	}

	static getAll (params) {
		return axios.get(baseURL, {
			params
		})
			.then(res => {
				return {
					...res.data,
					data: res.data.data.map(item => new Mentor(item))
				}
			})
			.catch(err => {
				console.error(err)
				return null
			})
	}

	async getSingle () {
		try {
			const {data} = await axios.get(`${baseURL}${this.id}`)
			this.setDefaultData(data.data)
		} catch (e) {
			console.error(e)
		}
	}

	update () {
		return axios.post(`${baseURL}${this.id}`, this.formData)
			.then(res => {
				return res
			})
			.catch(err => {
				console.error(err)
				return false
			})
	}

	create () {
		return axios.post(`${baseURL}`, this.formData)
			.then(res => {
				return res
			})
			.catch(err => {
				console.error(err)
				return false
			})
	}

	static deleteById (id) {
		return axios.delete(`${baseURL}${id}`)
			.then(res => {
				return res
			})
			.catch(err => {
				console.error(err)
				return false
			})
	}

	async delete () {
		try {
			const res = await axios.delete(`${baseURL}${this.id}`)
			return res
		} catch (e) {
			console.error(e)
			return false
		}
	}
}



// WEBPACK FOOTER //
// ./src/assets/js/Mentor.class.js